import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/audit';
export function Testimonials() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-287" data-mp="3fycpzlihi3a9">
      <div className="mx-auto w-full max-w-5xl" data-id="element-288" data-mp="3b1471ipihv7y">
        <SectionHeading eyebrow="⭐ What dentists are saying" title="What users are saying" data-id="element-289" data-mp="3b0aw05jisjk0" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-290" data-mp="36wmplq6mju0c">
          {testimonials.map((t, i) => <article key={t.name} className={['flex flex-col rounded-3xl bg-cream-100 p-5 ring-1 ring-navy-900/8 sm:p-6', i === 0 ? 'sm:col-span-2' : ''].join(' ')} data-id="element-291" data-mp="3229024en8h3l" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-292" data-mp="v859txg9hd2s">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-293" data-mp="q8ivtlslzssx" data-mpi={s} />)}
              </div>
              <h3 className="mt-3 font-display text-lg font-bold leading-snug text-navy-900 sm:text-xl" data-id="element-294" data-mp="780ivmr7388w">
                “{t.quote}”
              </h3>
              <p className="mt-2 flex-1 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-295" data-mp="c7dfv0bs5vp7">
                {t.text}
              </p>
              <div className="mt-5 flex items-center gap-3 border-t border-navy-900/10 pt-4" data-id="element-296" data-mp="14v9cy659hpmi">
                <img src={t.avatar} alt={`Portrait of ${t.name}`} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-297" data-mp="q6mp1g1kjpjo" />
                <div className="min-w-0" data-id="element-298" data-mp="1iuih27g70ta4">
                  <p className="text-sm font-bold text-navy-900" data-id="element-299" data-mp="1ith6s5704atg">{t.name}</p>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.06em] text-navy-700/55" data-id="element-300" data-mp="1nnblsvbnw1m7">
                    {t.role}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-301" data-mp="1ogt29tvwermi">
          <CTAButton label="Join them for $27" subLabel="Instant access · 7-day guarantee" data-id="element-302" data-mp="1ofzquflzvdy1" />
        </div>
      </div>
    </section>;
}